export default __webpack_public_path__ + "static/media/1866.d6aa1306.png";